import React from 'react';

export const RETAILER_LOGO_CONFIG = {
  flipkart: {
    src: 'https://www.google.com/s2/favicons?domain=flipkart.com&sz=256',
    alt: 'Flipkart'
  },
  amazon: {
    src: 'https://www.google.com/s2/favicons?domain=amazon.in&sz=256',
    alt: 'Amazon'
  },
  myntra: {
    src: 'https://www.google.com/s2/favicons?domain=myntra.com&sz=256',
    alt: 'Myntra'
  },
  whatsapp: {
    src: 'https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg',
    fallback:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/240px-WhatsApp.svg.png',
    alt: 'WhatsApp'
  }
};

const handleLogoError = (fallback) => (event) => {
  if (!fallback || event.currentTarget.src === fallback) {
    event.currentTarget.onerror = null;
    return;
  }

  event.currentTarget.src = fallback;
  event.currentTarget.onerror = null;
};

export const RetailerLogo = ({ platform, className = '' }) => {
  const config = RETAILER_LOGO_CONFIG[platform];

  if (!config) {
    return null;
  }

  const imgClassName = [
    'retailer-card-logo-img',
    platform === 'whatsapp' ? 'retailer-card-logo-img--whatsapp' : '',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <img
      src={config.src}
      alt={config.alt}
      className={imgClassName}
      width={80}
      height={80}
      onError={config.fallback ? handleLogoError(config.fallback) : undefined}
    />
  );
};

export const RETAILER_LOGOS = {
  flipkart: (props) => <RetailerLogo platform="flipkart" {...props} />,
  amazon: (props) => <RetailerLogo platform="amazon" {...props} />,
  myntra: (props) => <RetailerLogo platform="myntra" {...props} />,
  whatsapp: (props) => <RetailerLogo platform="whatsapp" {...props} />
};

export default RetailerLogo;